module.exports = "<div textColor=\"#AAA\" [ngStyle]=\"getMyStyle()\">\n  {{ count }}\n</div>\n"